// extracted by mini-css-extract-plugin
export default {"panel":"StylePanel_panel__s+apP","field":"StylePanel_field__NmIrb","group":"StylePanel_group__+qmfm","groups":"StylePanel_groups__FprYK","reset":"StylePanel_reset__2Ihyw"};